import { useMutation } from "@tanstack/react-query";
import {
  type RequestThanksToYouWithdrawalResult,
  postLeadsThanksToYouWithdrawalRequests,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: RequestThanksToYouWithdrawalResult) => void;
  onError?: (error: unknown) => void;
};

/**
 * Asks for the e-mail that confirms leaving Díky Tobě (ZS-1623). Nothing changes until the link in
 * it is used, so no query is invalidated; asking again revokes the earlier link.
 */
export const useRequestThanksToYouWithdrawalMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postLeadsThanksToYouWithdrawalRequests(),
    ),
    onSuccess,
    onError,
  });
